import { use_effect } from '@/hooks/_base/use_effect';
import i18n from '@/services/i18n/i18n';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';

export function WatcherLanguageFallbackPigdog() {
  /*
   * EFFECTS
   */

  use_effect(() => {
    if (i18n.language != ENUM__language_type.PIGDOG) return;

    void i18n.changeLanguage(ENUM__language_type.UKRAINIAN);
  }, []);

  return <></>;
}
